import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { xor } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';

import { UserpilotService } from '@app/src/app/shared/services/userpilot';

import { WeekdayToggleMessages } from './weekday-toggle.constants';
import { Weekday } from './weekday-toggle.types';
import { getNameOfWeeksDaysObservable } from './weekday-toggle.utils';

@Component({
  selector: 'mg-weekday-toggle',
  templateUrl: './weekday-toggle.component.html',
  styleUrls: ['./weekday-toggle.component.scss'],
})
export class WeekdayToggleComponent implements OnDestroy {
  /** Constants */
  public readonly MESSAGES: typeof WeekdayToggleMessages = WeekdayToggleMessages;

  /** Options */
  public readonly options$: Observable<string[]>;
  private readonly _activeOptions$ = new BehaviorSubject<string[]>([]);
  public readonly activeOptions$ = this._activeOptions$.asObservable();

  /** Inputs */
  @Input() readonly: boolean;
  @Input()
  set initialValue(val: string[]) {
    this._activeOptions$.next(val);
  }
  @Input() invalidDays: Weekday[] = [];
  /**
   * Unique id for things like analytics and testing to hook into
   * Important to note changing this could break either of those
   */
  @Input() id: string;

  /** Events */
  @Output()
  public readonly valueChanged = new EventEmitter<string[]>();

  /** Component Constructor */
  constructor(private _userpilot: UserpilotService) {
    this.options$ = getNameOfWeeksDaysObservable();
  }

  ngOnDestroy(): void {
    this._activeOptions$.complete();
  }

  public async toggleOption(day: string): Promise<void> {
    if (this.readonly) return;
    if (this.id) this._userpilot.track(`${this.id}-${day}`);

    const activeOptions = xor(this._activeOptions$.getValue(), [day]);
    this._activeOptions$.next(activeOptions);
    this.valueChanged.emit(activeOptions);
  }
}
